import * as configPH from '../config/ph/constant';
import * as configID from '../config/id/constant';

const COUNTRY_CODE = process.env.REACT_APP_COUNTRY_CODE || 'ph';
const configMap: Record<string, any> = {
  ph: configPH,
  id: configID,
};

const config = configMap[COUNTRY_CODE] || configPH;

export const {
  REDIRECT_URL,
  API_URL,
  APIV,
  apikey,
  API_VERSION_V2,
  KEY_ACTIVE_TAB_MAP,
  DESCRIPTION_VALIDATION,
  ROLE_NAME_VALIDATION,
  ROLE_FEATURES,
  DOC_UPLOAD_VALIDATION,
  AGENCY_STATUS,
  STATUS_SUB_STATUS,
  CURRENCY_CODE,
  CURRENCY_SYMBOL,
  APP_TYPE_AGENCY,
  USER_EMAIL_REGEX, 
  USER_NAME_VALIDATION, 
  USERLIST_MOBILE_REGEX, 
  USERLIST_PASSWORD_REGEX,USER_MOBILE_REGEX, 
  USER_PASSWORD_REGEX,
  ALLOW_ALPHABET,
  ALLOW_CHAR_NUM,
  KEY_LEAD_ACTIVE_TAB_MAP,
  KEY_PAYMENT_ACTIVE_TAB_MAP,
  MANAGER_LEVEL_IDS,
  RAGEX_NUMBER_UPTO_2_DECIMAL_PLACES,
  ROLES,
  LEAD_ADDON,
  SHOW_ACTION_STATUS,
  SHOW_ACTION_DOC_STATUS,
  MAINTENANCE_POLL_INTERVAL_MS
} = config;